<script setup>
defineProps({
    name: {
        type: String,
        required: true,
    },
});

const modelValue = defineModel({
    type: [String, Number, Boolean],
    required: true,
});
</script>

<template>
    <select
        v-model="modelValue"
        :name="name"
        class="border-neutrals-500 focus:ring-primary w-full border bg-white text-sm focus:ring-2 focus:outline-hidden"
    >
        <slot />
    </select>
</template>
